import { atom } from 'jotai';

export const editorContentAtom = atom<string>('');

export const pdfChangeAtom = atom<boolean>(false);

export const currently_generating = atom<string>('not_generating');